
<app-chat [messages]="messages"></app-chat>
